import './Rodape.css'; 

const Rodape = () => {
    return (
        <footer className="rodape">
            <p>Desenvolvido por <a href="https://github.com/paola-oliveira">Paola Oliveira</a></p>
        </footer>
    )
}

export default Rodape; 